import { useEffect, useMemo, useRef } from 'react';
import { useAppSelector } from '../../../hooks';
import {
  ApplicantRole,
  ApplicationType,
} from '../../../types/PartyApplication/partyApplication';
import FormBlock from 'components/formComponents/Layout/FormBlock';
import EnvelopeStripesIcon from '../../../images/envelope_w_stripes.svg?react';
import styles from './ConfirmationPage.module.scss';
import TextBlock from 'components/formComponents/Base/TextBlock';
import sanitize from 'sanitize-html';

const ConfirmationPage = () => {
  const { applicantRole, applicationType, pageTexts } = useAppSelector(
    (state) => state.partyApplication
  );
  const texts = useMemo(() => {
    return pageTexts?.confirmationSection;
  }, [pageTexts]);
  const pushedRef = useRef(false);

  useEffect(() => {
    if (pushedRef.current) return;
    pushedRef.current = true;
    const roleNumber =
      typeof applicantRole === 'string' ? Number(applicantRole) : applicantRole;

    const applicationForm: 'arbetsgivare' | 'facklig' =
      roleNumber === ApplicantRole.companyRepresentative
        ? 'arbetsgivare'
        : 'facklig';

    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push({
      event: 'application_submitted',
      application_form: applicationForm,
    });
  }, [applicantRole]);

  const applicationTypeText = useMemo(() => {
    return applicationType === ApplicationType.companyBankruptcy
      ? (texts?.confirmationUnionContactPreamble ?? '')
      : (texts?.confirmationCompanyAndUnionContactPreamble ?? '');
  }, [applicationType, texts]);

  return (
    <FormBlock title={texts?.confirmationHeadline ?? 'Tack för din ansökan!'}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <EnvelopeStripesIcon />
        </div>
        <TextBlock type="info" text={applicationTypeText} />
        <div className={styles.subSection}>
          <p className={styles.subheader}>
            {texts?.confirmationWhatHappensNowSubHeader ?? 'Vad händer nu?'}
          </p>
          <div
            dangerouslySetInnerHTML={{
              __html: sanitize(texts?.confirmationWhatHappensNowPreamble ?? ''),
            }}
          />
        </div>
      </div>
    </FormBlock>
  );
};

export default ConfirmationPage;
